import type { ReactNode } from 'react';
import { classNames } from '@/lib/utils';
import { TEXTURES } from '@/lib/assets';

interface PanelProps {
  title: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}

export function Panel({ title, children, className, action }: PanelProps): JSX.Element {
  return (
    <section
      className={classNames(
        'relative overflow-hidden rounded-lg',
        'border-2 border-wood-mid/70',
        'shadow-[0_4px_16px_rgba(0,0,0,0.55),inset_0_1px_0_rgba(255,255,255,0.08)]',
        'transition-transform duration-200 ease-out hover:scale-[1.008]',
        className,
      )}
      aria-label={title}
      style={{
        backgroundImage: `url("${TEXTURES.parchment}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Warm tint overlay so text stays readable over any texture region */}
      <div className="absolute inset-0 bg-parchment/80 pointer-events-none" />

      <div className="relative">
        <header className="flex items-center justify-between gap-3 border-b-2 border-wood-mid/30 px-4 sm:px-5 py-3">
          <h2 className="font-display text-base sm:text-lg uppercase tracking-[0.2em] text-wood-dark">
            {title}
          </h2>
          {action && <div className="text-xs text-ink-mid">{action}</div>}
        </header>
        <div className="px-4 sm:px-5 py-4">{children}</div>
      </div>
    </section>
  );
}
